import { KPI_TILE_VARIANTS } from '../components/molecules/KpiTile';
import { displayNumber, formatKpiDelta } from '../chatView/components/artifacts/kpiFormat';
import { METRIC_TONES } from './constants';

const TONE_VARIANTS = {
    [METRIC_TONES.GOOD]: KPI_TILE_VARIANTS.POSITIVE,
    [METRIC_TONES.BAD]: KPI_TILE_VARIANTS.NEGATIVE,
    [METRIC_TONES.NEUTRAL]: KPI_TILE_VARIANTS.NEUTRAL,
};

export const formatVerdictValue = (value, displayFormat, { compact = true } = {}) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return value == null ? 'N/A' : String(value);
    }
    return displayNumber(value, displayFormat, { compact });
};

export const buildVerdictDelta = (delta, tone) => {
    const formatted = formatKpiDelta(delta);
    if (!formatted) return null;
    return { ...formatted, variant: TONE_VARIANTS[tone] ?? KPI_TILE_VARIANTS.NEUTRAL };
};
